import { getChartLabel } from "./chartLabel";
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
  Cell,
} from "recharts";
import { useState } from "react";
import { Form } from "react-bootstrap";
import CustomTooltip from "./CustomTooltip";
import CustomLegend from "./CustomLegend";
import CustomTooltipSTI from "./CustomTooltipSTI";
//kpi 6
const OstManaged = ({ data, filters, selectedState }) => {
  const [showTable, setShowTable] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortColumn, setSortColumn] = useState("Percentage");
  const [sortOrder, setSortOrder] = useState("asc");
  const itemsPerPage = 10;

  const getColor = (value) => {
    if (value < 100) return "#dc3545"; // Red
    if (value == 100) return "#00a084";
    return "#ffc40c"; // Green
  };

  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <h5 style={{ color: "#666", fontSize: "20px" }}>No data available</h5>
      </div>
    );
  }
  const STIData = data.map((item) => {
    return {
      place: item.Place,
      STI_Symptomatic: Number(item.individual_found_STI_Symptomatic),
      STI_Managed: Number(item.STI_Managed),
      Percentage: Number(item.Percentage_of_STI_managed),
    };
  });

  const sortedData = [...STIData].sort((a, b) => {
    if (sortColumn === "Percentage") {
      return sortOrder === "asc"
        ? a[sortColumn] - b[sortColumn]
        : b[sortColumn] - a[sortColumn];
    }
    return 0; // No sorting for other columns
  });

  const handleSort = (column) => {
    if (column !== "Percentage") return; // Prevent sorting other columns
    if (sortColumn === column) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };

  const chunkArray = (array, chunkCount) => {
    const result = [];
    const chunkSize = Math.ceil(array.length / chunkCount);

    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }

    return result;
  };

  const getChartCount = (length) => {
   if (length < 9) return 1;
    if (length >= 9 && length <= 18) return 2;
    if (length <= 45) return 3;
    return Math.ceil(length / 20);
  };

  const chartCount = getChartCount(STIData.length);
  const chunkedData = chunkArray(STIData, chartCount);

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div className="card hptCard mt-4 border-0">
        <div class="card-header brBtomlr">
          <div class="headnumText justify-content-between">
            <div class="cardTitle d-flex align-items-center gap-3">
              <h5>STI Management {getChartLabel(filters, selectedState)}</h5>
            </div>

            <div class="cardDropDown gap-3">
              <div style={{ marginRight: "10px", fontWeight: 500 }}>
                {showTable ? "Chart View" : "Table View"}
              </div>
              <Form>
                <Form.Check
                  type="switch"
                  id="chart-table-toggle"
                  onChange={() => setShowTable((prev) => !prev)}
                  checked={showTable}
                />
              </Form>
            </div>
          </div>
        </div>
      </div>
      {showTable ? (
        // Table View
        <div className="card hptCard mt-4 border-0">
          <div className="table-responsive">
            <table className="table  table-bordered ">
              <thead className="thead-light">
                <tr>
                  <th className="fw-bold">Place</th>
                  <th className="text-center fw-bold ">STI Symptomatic</th>
                  <th className="text-center fw-bold ">STI Managed</th>
                  <th
                    className="text-center fw-bold cursor-pointer"
                    onClick={() => handleSort("Percentage")}
                  >
                    Percentage of STI Managed{" "}
                    {sortColumn === "Percentage"
                      ? sortOrder === "asc"
                        ? "▲"
                        : "▼"
                      : "⬍"}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((item, idx) => (
                  <tr key={idx}>
                    <td className=" fw-bold ">{item.place}</td>
                    <td>{item.STI_Symptomatic}</td>
                    <td>{item.STI_Managed}</td>
                    <td
                      style={{
                        backgroundColor: getColor(item.Percentage),
                        textAlign: "center",
                        color: "white",
                      }}
                    >
                      {item.Percentage}%
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        // Chart View
        <>
          {chunkedData.map((chunk, index) => (
            <div className="card hptCard mt-4 border-0">
              <div className="card-body">
                <h6 style={{ fontWeight: "bold" }}>
                  STI Symptomatic vs Managed
                </h6>
              </div>
              <ResponsiveContainer width="100%" height={500}>
                <BarChart
                  width={500}
                  height={500}
                  data={chunk}
                  margin={{
                    top: 20,
                    right: 30,
                    left: 20,
                    bottom: 130,
                  }}
                >
                  {/* <CartesianGrid strokeDasharray="3 3" /> */}
                  <XAxis
                    dataKey="place"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    label={{
                      value: "",
                      position: "insideBottom",
                      offset: -110,
                      color: "#ca8282ff",
                      fontWeight: "bold",
                    }}
                  />
                  <YAxis yAxisId="left" orientation="left" />

                  <Tooltip content={<CustomTooltip />} />
                  <Legend
                    verticalAlign="top"
                    content={
                      <CustomLegend
                        order={["STI Symptomatic", "STI Managed"]}
                      />
                    }
                  />

                  <Bar
                    yAxisId="left"
                    dataKey="STI_Symptomatic"
                    fill="#00a084"
                    name="STI Symptomatic"
                  >
                    <LabelList
                      dataKey="STI_Symptomatic"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                  <Bar
                    yAxisId="left"
                    dataKey="STI_Managed"
                    fill="#ffc40c"
                    name="STI Managed"
                  >
                    <LabelList
                      dataKey="STI_Managed"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          ))}
          {/* <br/> */}
          {chunkedData.map((chunk, index) => (
            <div className="card hptCard mt-4 border-0">
              <div className="card-body">
                <h6 style={{ fontWeight: "bold" }}>
                  Percentage of STI Managed
                </h6>
              </div>

              <ResponsiveContainer width="100%" height={500}>
                <BarChart
                  width={500}
                  height={500}
                  data={chunk}
                  margin={{
                    top: 60,
                    right: 30,
                    left: 20,
                    bottom: 130,
                  }}
                >
                  {/* <CartesianGrid strokeDasharray="3 3" /> */}
                  <XAxis
                    dataKey="place"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    label={{
                      value: "",
                      position: "insideBottom",
                      offset: -110,
                      color: "#ca8282ff",
                      fontWeight: "bold",
                    }}
                  />
                  <YAxis yAxisId="left" orientation="left" />
                  <Tooltip content={<CustomTooltipSTI />} />
                  {/* <Legend
                  verticalAlign="top"
                  content={<CustomLegend order={["Percentage"]} />}
                /> */}

                  <Bar yAxisId="left" dataKey="Percentage" fill="#dd1e47">
                    {" "}
                    {STIData.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={entry.Percentage == 100 ? "#00a084" : "#dd1e47"}
                      />
                    ))}
                    <LabelList
                      dataKey="Percentage"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          ))}
        </>
      )}
    </div>
  );
};
export default OstManaged;
